
    import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
    import baseUrl, {imageUrl} from "@/constants";
    import {uploadApi} from "@/api/upload";
    import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
    import EmptyContent from "@/components/EmptyContent.vue";
    @Component({
        name: "UploadInstrumentImg",
        components:{EmptyContent, ElImageViewer}
    })
    export default class Home extends Vue {
        @Prop()
        private keyName !: any; //传入的key
        @Prop()
        private fileData !: any;
        typeCode = "";
        headers = {Authorization:""}
        baseUrl = baseUrl
        imageUrl = imageUrl
        isShow = false;
        dialogImageUrl = "";
        imagePreviewVisible = false;
        FileData = {
            //计量标准器
            "10" : [{key: 'publicCert', name: '社会公用计量标准证书\n或\n计量标准考核证书', accept: '.pdf', desc: '限PDF格式', fileList: []},{key: 'lastTest',name: '最近一次计量标准器\n检定证书', accept: '.pdf', desc: '限PDF格式', fileList: []}, {key: 'modelImage', name: '含有出厂编号\n规格型号的铭牌图片', accept: '.jpg,.png', desc: '限jpg/png格式', fileList: []}],
            //贸易结算
            "6" : [{key: 'tradeProved',name: '贸易结算的相关证明', accept: '.pdf', desc: '限PDF格式', fileList: []}, {key: 'lastTestOrBill', name: '最近一次检定证书或\n新购置器具的购销合同\n或发票', accept: '.pdf', desc: '限PDF格式', fileList: []}, {key: 'modelImage', name: '含有出厂编号\n规格型号的铭牌图片', accept: '.jpg,.png', desc: '限jpg/png格式', fileList: []}],
            //医疗卫生
            "4" : [{key: 'lastTestOrBill',name: '最近一次检定证书或\n新购置器具的购销合同\n或发票', accept: '.pdf', desc: '限PDF格式', fileList: []}, {key: 'modelImage', name: '含有出厂编号\n规格型号的铭牌图片', accept: '.jpg,.png', desc: '限jpg/png格式', fileList: []}],
            //安全防护
            "3" : [{key: 'lastTestOrBill',name: '最近一次检定证书或\n新购置器具的购销合同\n或发票', accept: '.pdf', desc: '限PDF格式', fileList: []},{key: 'modelImage', name: '含有出厂编号\n规格型号的铭牌图片', accept: '.jpg,.png', desc: '限jpg/png格式', fileList: []}, {key: 'locationImage',name: '安装物理位置的图片', accept: '.jpg,.png', desc: '限jpg/png格式', fileList: []}],
            //环境监测
            "5" : [{key: 'lastTestOrBill',name: '最近一次检定证书或\n新购置器具的购销合同\n或发票', accept: '.pdf', desc: '限PDF格式', fileList: []},{key: 'modelImage', name: '含有出厂编号\n规格型号的铭牌图片', accept: '.jpg,.png', desc: '限jpg/png格式', fileList: []}],
            "其他": [{key: 'otherImage0', name: '资料一', accept: '.jpg,.png,.pdf', desc: '', fileList: []}, {key: 'otherImage1', name: '资料二', accept: '.jpg,.png,.pdf', desc: '', fileList: []}, {key: 'otherImage2', name: '资料三', accept: '.jpg,.png,.pdf', desc: '', fileList: []}],
        } as any;
        fileEl = [];

        created() {
            this.typeCode = this.keyName;
            this.getFileData(true);
        }
        @Watch("typeCode")
        valueChanged(val: string) {
            this.typeCode = String(val);
            this.getFileData(false);
        }
        onDataValidate(){
            let isNull = false;
            // if(this.typeCode == '9' || this.typeCode == '11'){
            //     this.isShow = false;
            //    return false;
            // }
            // this.fileEl.forEach((el: any) => {
            //     if(el.fileList.length === 0){
            //         isNull = true;
            //     }
            // });
            // this.isShow = true;
            return isNull;
        }
        getFileData(isCreated: boolean){
            let fileList = this.FileData[this.typeCode];
            if(fileList === undefined){
                fileList = this.FileData["其他"];
            }
            if(isCreated){
                let fileData = {} as any;
                if(this.fileData){
                    fileData = JSON.parse(this.fileData);
                }
                for(const key in fileData){
                    const file = fileList.find((f: any) => f.key === key);
                    if(file != undefined && file != null){
                        file.fileList = fileData[key];
                    }
                }
            }
            this.fileEl = fileList;
        }
        httpRequestUpload(param: any){
            const {data} = param;
            if(!this.checkFileType(param.file, data.el)){
                return;
            }
            let formData = new FormData();
            formData.append('file', param.file);
            formData.append('category', data.category);
            uploadApi.upload(formData).then((r: any) => {
                if(r.data.result === 0){
                    data.el.fileList.push({name: data.el.name, url: r.data.data});
                    this.sendData('onChange');
                }
            });
        }

        checkFileType(file: any, el: any) {
            if(el.accept == ".jpg,.png"){
                const isJPG = file.type === 'image/jpeg';
                const isPNG = file.type === 'image/png';
                if (!isJPG && !isPNG) {
                    this.$message.error('上传图片只能是 JPG/PNG 格式!');
                }
                return (isJPG || isPNG);
            }else if(el.accept == ".pdf"){
                const isPDF = file.type === 'application/pdf';
                if (!isPDF) {
                    this.$message.error('上传文件只能是 PDF 格式!');
                }
                return (isPDF);
            }else if(el.accept ==".jpg,.png,.pdf"){
                const isJPG = file.type === 'image/jpeg';
                const isPNG = file.type === 'image/png';
                const isPDF = file.type === 'application/pdf';
                if (!isPDF && !isPNG && !isJPG) {
                    this.$message.error('上传文件只能是 JPG/PNG/PDF 格式!');
                }
                return (isJPG || isPNG || isPDF);
            }
        }
        sendData(mode: string) {
            const data = {} as any;
            this.fileEl.forEach((el: any) => {
                data[el.key] = el.fileList;
            });
            this.$emit(mode , JSON.stringify(data));
        }
        onRemove(file: any){
            this.fileEl.forEach((el: any) => {
                const {fileList} = el;
                const index = fileList.findIndex((e: any) => e.url === file.url);
                if (index > -1) {
                    fileList.splice(index, 1);
                }
            });
            this.sendData('onChange');
        }
        filesuffix(fileName: string) {
            const first = fileName.lastIndexOf(".");//取到文件名开始到最后一个点的长度
            const namelength = fileName.length;//取到文件名长度
            const filesuffix = fileName.substring(first + 1, namelength);//截取获得后缀名
            return filesuffix;
        }
        onPreview(file: any) {
            const fix = this.filesuffix(file.url);
            if (fix == "pdf" || fix == "xlsx" || fix == "xls") {
                window.open(baseUrl + "/file/download?file=" + file.url + "&name=" + file.name, '_blank');
            } else {
                this.dialogImageUrl = imageUrl + file.url;
                this.imagePreviewVisible = true;
            }
        }
        // 关闭查看器
        closeViewer() {
            this.imagePreviewVisible = false;
        }
    }
